<template lang="pug">
  .personal-profile.gray-bg
    .section
      partners(
        v-if="userType === CONSTANTS.SENDER_PROFILE_TYPE || userType === CONSTANTS.RECEIVER_PROFILE_TYPE"
        :sender="userType === CONSTANTS.SENDER_PROFILE_TYPE"
      )
      .container.has-text-centered(v-else)
        h2 {{ employer ? gettext('Company profile') : gettext('Personal information') }}
        .personal-profile-grid
          .main
            .jobseeker(v-if="!employer")
              .field.is-horizontal
                label.label.name {{ gettext('Name') }}*
                .field-body
                  input.input(
                    name="first_name"
                    v-model="form.first_name"
                    @input="form.first_name = validateLatinCharacter($event)"
                    :placeholder="gettext('Only latin letters')"
                    v-tooltip="{content: errors.server.first_name || errors.first_name, show: tooltip.first_name}"
                    @blur="validateData('first_name')"
                    :class="{'is-danger': $v.form.first_name.$error }")
              .field.is-horizontal
                label.label.name {{ gettext('Surname') }}*
                .field-body
                  input.input(
                    name="last_name"
                    v-model="form.last_name"
                    @input="form.last_name = validateLatinCharacter($event)"
                    :placeholder="gettext('Only latin letters')"
                    v-tooltip="{content: errors.server.last_name || errors.last_name, show: tooltip.last_name}"
                    @blur="validateData('last_name')"
                    :class="{'is-danger': $v.form.last_name.$error }")
              .field.is-horizontal
                label.label.name {{ gettext('Original nationality') }}*
                .field-body(@click="$v.form.country.$touch()")
                  ajax-multiselect.wide(
                    v-model="form.country"
                    :labelText="gettext('Choose the country')"
                    :itemName ="'name'"
                    :action="{method: 'receiveCountries', params:{lang: getLanguage, filters: ['for_jobseeker_profile']}}",
                    :multiple="false"
                    :searchable="true"
                    :hideSelected="true"
                    :closeOnSelect="true"
                  )
              .field.is-horizontal
                label.label.name {{ gettext('Data of birth') }}
                .field-body
                  datepicker(
                    :inputClass="'input'"
                    v-model="form.birth_date")
              .field.is-horizontal
                label.label.name {{ gettext('Marital status') }}
                .field-body
                  ajax-dropdown.wide(
                    v-model="form.marital_status"
                    :labelText="gettext('Choose status')"
                    :action="{method: 'receiveMaritalStatuses', params: {lang: getLanguage}}",
                    :itemName ="'name'",
                    :option="gettext('none')"
                  )
              .field.is-horizontal
                label.label.name {{ gettext('Gender') }}
                .field-body.row-pos
                  span.radio-wrap
                    input.is-checkradio#gender-male(type="radio" name="gender" :value='10' v-model="form.gender")
                    label(for="gender-male") {{ gettext('Male') }}
                  span.radio-wrap
                    input.is-checkradio#gender-female(type="radio" name="gender" :value='20' v-model="form.gender")
                    label(for="gender-female") {{ gettext('Female') }}
              .field.is-horizontal.linned-bottom
                label.label.name
                .field-body
                  label.label.edit
              .field.is-horizontal.notification.is-warning(v-if="nonFilled && nonFilled.some(i => ~['location_country', 'location_region', 'location_staying_type'].indexOf(i))")
                .field-body.info#info
                  .mdi.mdi-information-outline.mdi-24px &nbsp;
                  | {{ gettext('Please enter your current placement!') }}
              .field.is-horizontal
                label.label.name.font {{ gettext('Placement') }}
                .field-body
                  label.label.edit
              .field.is-horizontal
                label.label.name {{ gettext('Country of residence') }}*
                .field-body(@click="$v.form.location_country.$touch()")
                  ajax-multiselect.wide(
                  v-model="form.location_country"
                  v-tooltip="{content: errors.required, show: tooltip.location_country}"
                  :labelText="gettext('Choose your country')"
                  :itemName ="'name'"
                  :action="{method: 'receiveCountries', params: {lang: getLanguage}}"
                  :class="{'is-danger': $v.form.location_country.$error, 'is-empty': !form.location_country.length}"
                  :multiple="false"
                  :searchable="true"
                  :hideSelected="true"
                  :closeOnSelect="true"
                  @updated="countryUpdateHandler()"
                  @selected="getStayingTypes"
                  )
              .field.is-horizontal(v-if="(form.location_country || {}).id")
                label.label.name {{ gettext('Region of residence') }}*
                .field-body(@click="$v.form.location_region.$touch()")
                  ajax-dropdown.wide(
                  v-tooltip="{content: errors.required, show: tooltip.location_region}"
                  v-model="form.location_region"
                  :labelText="gettext('Choose the region')"
                  :itemName ="'name'"
                  :class="{'is-danger': $v.form.location_region.$error, 'is-empty': !form.location_region.length }"
                  :action="regionAction",
                  :multiple="false"
                  :searchable="true"
                  :hideSelected="true"
                  :closeOnSelect="true"
                  :disabled="!form.location_country.id"
                  )
              .field.is-horizontal(v-if="(form.location_country || {}).id")
                label.label.name {{ gettext('Type of residence permit') }}*
                .field-body(@click="$v.form.location_staying_type.$touch()")
                  ajax-dropdown.wide(
                  v-model="form.location_staying_type"
                  :labelText="gettext('Choose type of residence permit')"
                  :itemName ="'name'"
                  :action="placementAction",
                  :disabled="!form.location_country.id"
                  )
            .empoyer(v-if="employer")
              .field.is-horizontal
                label.label.name {{ gettext('Name of company') }}*
                .field-body
                  input.input(
                    name="company-name"
                    :placeholder="gettext('Only latin letters')"
                    :disabled="!allowEdit"
                    @blur="validateData('company_name')"
                    v-tooltip="{content: !allowEdit ? gettext('These data can only be changed by contacting customer support'): errors.first_name, show: tooltip.company_name}"
                    @input="form.company_name = validateLatinCharacter($event)"
                    :class="{'is-danger': $v.form.company_name.$error }"
                    v-model="form.company_name")
                  label.label.edit
                    .mdi.mdi-comment-question-outline.icon-edit(v-if="!allowEdit" @click="toogleInfoshow('company_name')")
              .field.is-horizontal(@click="validateData('company_type')")
                label.label.name {{ gettext('Type of company') }}*
                .field-body
                  ajax-dropdown.wide(
                  v-if="form.country.iso2"
                  v-tooltip="{content: !allowEdit ? gettext('These data can only be changed by contacting customer support'): errors.first_name, show: tooltip.company_type}"
                  v-model="form.company_type"
                  :disabled="!allowEdit"
                  :itemName="'name'"
                  :class="{'is-danger': $v.form.company_type.$error }"
                  :labelText="gettext('Choose the type')"
                  :action="{method: 'receiveCompanyTypes', params: {lang: getLanguage, country: form.country.id}}",
                  )
                  label.label.edit
                    .mdi.mdi-comment-question-outline.icon-edit(v-if="!allowEdit" @click="toogleInfoshow('company_type')")
              .field.is-horizontal
                label.label.name {{ gettext('Country') }}*
                .field-body
                  ajax-dropdown.wide(
                    v-tooltip="{content: !allowEdit ? gettext('These data can only be changed by contacting customer support'): errors.first_name, show: tooltip.country}"
                    v-model="form.country"
                    :labelText="gettext('Choose the country')"
                    @selected="form.region.id ? form.region = '': false"
                    :action="{method: 'receiveCountries', params:{lang: getLanguage, filters: ['for_employer_profile']}}",
                    :itemName ="'name'"
                    :disabled="true"
                  )
                  label.label.edit
                    .mdi.mdi-comment-question-outline.icon-edit(@click="toogleInfoshow('country')")
              .field.is-horizontal(@click="validateData('region')")
                label.label.name {{ gettext('Region') }}*
                .field-body
                  ajax-dropdown.wide(
                    v-if="form.country.iso2"
                    v-tooltip="{content: !allowEdit ? gettext('These data can only be changed by contacting customer support') : errors.required, show: tooltip.region}"
                    v-model="form.region"
                    :disabled="!allowEdit"
                    :labelText="gettext('Choose the region')"
                    :class="{'is-danger': $v.form.region.$error }"
                    :action="{method: 'receiveRegions', params: {lang: getLanguage, country: form.country.iso2}}",
                    :itemName ="'name'"
                  )
                  label.label.edit
                    .mdi.mdi-comment-question-outline.icon-edit(v-if="!allowEdit" @click="toogleInfoshow('region')")
              .field.is-horizontal
                label.label.name {{ gettext('Registration number') }}*
                .field-body
                  input.input(
                  name="registration-number"
                  type="text"
                  @blur="validateData('company_reg_number')"
                  :disabled="!allowEdit"
                  :class="{'is-danger': $v.form.company_reg_number.$error }"
                  v-tooltip="{content: !allowEdit ? gettext('These data can only be changed by contacting customer support'): errors.first_name, show: tooltip.company_reg_number}"
                  v-model="form.company_reg_number")
                  label.label.edit
                    .mdi.mdi-comment-question-outline.icon-edit(v-if="!allowEdit" @click="toogleInfoshow('company_reg_number')")
              .field.is-horizontal
                label.label.name {{ gettext('Contact person') }}*
                .field-body
                  input.input(
                    name="contact-person"
                    v-tooltip="{content: errors.contact_person, show: tooltip.contact_person}"
                    @blur="validateData('contact_person')"
                    @input="form.contact_person = validateLatinCharacter($event)"
                    :placeholder="gettext('Only latin letters')"
                    :class="{'is-danger': $v.form.contact_person.$error }"
                    v-model="form.contact_person")
                  label.label.edit

              .field.is-horizontal
                label.label.name {{ gettext('Phone number') }}*
                .field-body
                  v-phone-input(
                  name="phone"
                  v-tooltip="{content: errors.server.contact_phone || errors.contact_phone, show: tooltip.contact_phone}"
                  @blur="validateData('contact_phone')"
                  :class="{'is-danger': $v.form.contact_phone.$error }"
                  type="text"
                  @onInput="form.contact_phone = $event.number"
                  :phone="form.contact_phone"
                  @valid="phoneValid = $event"
                  )
                  label.label.edit

              .field.is-horizontal
                label.label.name {{ gettext('Website') }}
                .field-body
                  input.input(
                    name="site"
                    :class="{'is-danger': (errors.server.contact_website && !form.contact_website)}"
                    v-tooltip="{content: errors.server.contact_website, show: (errors.server.contact_website && !form.contact_website)}"
                    @input="form.contact_website = validateLatinCharacter($event)"
                    :placeholder="gettext('Only latin letters')"
                    v-model="form.contact_website")
                  label.label.edit

              .field.is-horizontal
                label.label.name {{ gettext('About') }}
                .field-body
                  textarea.textarea(
                    name="about"
                    :placeholder="gettext('Only latin letters')"
                    @input="form.company_about = validateLatinCharacter($event)"
                    v-model="form.company_about")
                  label.label.edit

            .field.is-horizontal
              label.label.name
              .field-body
                button.main-btn.col-white.bg-red.btn-big(@click="updateProfile" :disabled="imageLoading || !formIsValid || cropped") {{gettext('Save') }}
                label.label.edit(v-if="employer")

            .field.is-horizontal.linned-bottom
              label.label.name
              .field-body
                label.label.edit
            .field.is-horizontal(v-if="false")
              label.label.name.font.full {{ gettext('Social connections') }}
              .field-body
                label.label.edit
            .field.is-horizontal(v-if="false")
              label.label.name
              .field-body.has-icon.icon-black
                button.main-btn.bg-transparent.google
                  | {{ gettext('Use Google account') }}
                  img(src="/webapp/images/icons/google.svg")
                label.label.edit
            .field.is-horizontal(v-if="false")
              .field-body.has-icon.icon-black
                button.main-btn.bg-transparent.facebook
                  | {{ gettext('Use Facebook account') }}
                  i.mdi.mdi-facebook
                label.label.edit

            .field.is-horizontal
              label.label.name.font {{ gettext('Security') }}
              .field-body
                label.label.edit

            div(v-if="showPassFields" )
              .field.is-horizontal(v-if="getUser.has_password")
                label.label.name {{ gettext('Current password') }}*
                .field-body
                  input.input(
                    v-tooltip="{content: (errors.server.changePassFields || {}).current_password, show: (tooltip.current_password)}"
                    name="current_password"
                    type="password"
                    onfocus="this.removeAttribute('readonly');"
                    readonly
                    autocomplete="off"
                    v-model="changePassFields.current_password"
                    :class="{'is-danger': $v.changePassFields.current_password.$error }"
                    @blur="validateData('current_password', 'changePassFields')"
                    )
                  label.label.edit(v-if="employer")
              .field.is-horizontal
                label.label.name {{ gettext('New password') }}*
                .field-body
                  input.input(
                    name="new_password"
                    type="password"
                    onfocus="this.removeAttribute('readonly');"
                    readonly
                    autocomplete="off"
                    v-model="changePassFields.new_password1"
                    :class="{'is-danger': $v.changePassFields.new_password1.$error }"
                    @input="$v.changePassFields.new_password1.$touch()"
                    )
                  label.label.edit(v-if="employer")
              .field.is-horizontal
                label.label.name {{ gettext('Repeat new password') }}*
                .field-body
                  input.input(
                  name="repeat_new_password"
                  type="password"
                  onfocus="this.removeAttribute('readonly');"
                  readonly
                  autocomplete="off"
                  v-model="changePassFields.new_password2"
                  @input="$v.changePassFields.new_password2.$touch()"
                  :class="{'is-danger': $v.changePassFields.new_password2.$error }"
                  )
                  label.label.edit(v-if="employer")
            .field.is-horizontal
              label.label.name
              .field-body
                button.main-btn.col-white.bg-black.btn-big(
                @click="changePass"
                :disabled="showPassFields && !formPassIsValid"
                )  {{ !this.showPassFields ? gettext('Change password') : gettext('Save new password') }}
                label.label.edit(v-if="employer")
            div(v-if="showDeleteFields" )
              .field.is-horizontal(v-if="getUser.has_password")
                label.label.name {{ gettext('Your password') }}*
                .field-body
                  input.input(
                  v-tooltip="{content: (errors.server.deleteAccountFields || {}).current_password, show: (tooltip.current_password)}"
                  name="delete_current_password"
                  type="password"
                  v-model="deleteAccountFields.current_password"
                  :class="{'is-danger': $v.deleteAccountFields.current_password.$error }"
                  @blur="validateData('current_password', 'deleteAccountFields')"
                  )
                  label.label.edit(v-if="employer")
            .field.is-horizontal
              label.label.name
              .field-body
                button.main-btn.col-white.bg-black.btn-big(
                v-if="getUser.has_password"
                @click="deleteAccount"
                :disabled="showDeleteFields && !formDelIsValid"
                )  {{ gettext('Delete account') }}
                button.main-btn.col-white.bg-black.btn-big(
                v-else
                @click="showDeleteModal = true"
                :disabled="showDeleteFields && !formDelIsValid"
                )  {{ gettext('Delete account') }}
                label.label.edit(v-if="employer")
          image-cropper(
            ref="imageCropper"
            :cropButtonText="gettext('Crop image')"
            :rotateButtonText="gettext('Rotate')"
            :rotate="true"
            :customStrings="{ drag: employer ? gettext('Upload logo') : gettext('Upload image'), change: gettext('Change Photo'), remove: gettext('Remove Photo') }"
            @cropped="loadImage"
            @remove="form.image = ''"
            @update="cropped = !cropped"
            :resize="employer"
            v-model="image"
            :class="employer ? 'employer' : ''"
            )
          .company-info(v-if="employer")
            div
              strong {{ gettext('Registration number') }}:&nbsp;
              p {{ form.company_reg_number }}
            div
              strong {{ gettext('Company branch') }}:&nbsp;
              p {{ form.company_type_name }}
          .list
            router-link.field.is-horizontal(:to="{name: 'Cabinet', params: {lang: getLanguage}}" v-if="employer")
              .img-wrap
                img.cabinet-img(src="@/assets/images/icons/cabinet.png")
              | {{ gettext('List of invoices') }}
            router-link.field.is-horizontal(v-if="employer" :to="{name: 'BoughtServices', params: {lang: getLanguage}}")
              .img-wrap
                img(src="@/assets/images/icons/list-square.png")
              | {{ gettext('Bought services') }}
            router-link.field.is-horizontal(:to="{name: 'MyCVS', params: {lang: getLanguage}}" v-if="!employer")
              .img-wrap
                img(src="@/assets/images/icons/list-square.png")
              | {{ gettext('My CV`s') }}
            router-link.field.is-horizontal(:to="{name: 'MyJobs', params: {lang: getLanguage}}" v-else)
              .img-wrap
                img(src="@/assets/images/icons/list-square.png")
              | {{ gettext('List of jobs') }}
            router-link.field.is-horizontal(:to="{name: 'Favorites', params: {lang: getLanguage}}")
              .img-wrap
                img(src="@/assets/images/icons/list-square.png")
              | {{ gettext('Wish list') }}
            .field.is-horizontal.linned-bottom
              label.label.name
              .field-body
              label.label.edit
            .field.is-horizontal(@click="exit")
              .img-wrap
                img(src="@/assets/images/icons/log-out.png")
              | {{ gettext('Logout') }}
            .field.is-horizontal.download-personal(@click="downloadPersonalData") {{ gettext('Download your personal information') }}
    v-modal(:show.sync="showDeleteModal" :clickAway="true")
      section.modal-card-body
        .is-size-4.has-text-centered.title {{ gettext('Are you sure want to delete your account') }}?
        .btn-wrap
          a.main-btn.col-white.bg-red.nav-item.is-tab(@click="deleteAccount") {{ gettext('Yes') }}
          a.main-btn.col-white.bg-black.nav-item.is-tab(@click="showDeleteModal = false") {{ gettext('No') }}
    v-modal(:show.sync="showDownloadPersonalData" :clickAway="true")
      section.modal-card-body
        .is-size-4.has-text-centered.text {{ gettext('You can download a copy of your personal information from the Bixter.work at any time. We will prepare a file. Downloading your information is a secure password-protected and that is available only to you. If you want to safe a copy of your data from the Bixter.work, please press "Download" or "Cancel" if you want to wait. You can back here at any time.') }}
        .btn-wrap
          a.main-btn.col-white.bg-red.nav-item.is-tab(:href="userExportUrl" target="_blank" @click="showDownloadPersonalData = false") {{ gettext('Download') }}
          a.main-btn.col-white.bg-black.nav-item.is-tab(@click="showDownloadPersonalData = false") {{ gettext('Cancel') }}
</template>

<script>
import Vue from 'vue'
import { gettext } from '@/services/TranslateHandler'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import AjaxDropdown from '@/components/ajax-dropdown'
import AjaxMultiselect from '@/components/ajax-multiselect'
import Vuelidate from 'vuelidate'
import { required, email, sameAs, requiredIf } from 'vuelidate/lib/validators'
import Datepicker from '@/components/datepicker'
import VTooltip from 'v-tooltip'
import ImageCropper from '@/components/image-cropper'
import VPhoneInput from '@/components/v-phone-input'
import mixin from '@/mixins'
import Partners from './parts/partners'
import VModal from '@/components/modal'

const toastr = require('toastr')
const CONSTANTS = require('@/constants.json')
const _ = require('lodash')

Vue.use(Vuelidate)
Vue.use(VTooltip, {
  defaultTrigger: 'manual'
})

export default {
  name: 'PersonalProfile',
  mixins: [
    mixin
  ],
  components: {
    Partners,
    AjaxDropdown,
    AjaxMultiselect,
    Datepicker,
    ImageCropper,
    VPhoneInput,
    VModal
  },
  metaInfo () {
    return this.getMetaInfoMixin({defaultMetaInfo: this.defaultMetaInfo})
  },
  data () {
    return {
      CONSTANTS: CONSTANTS,
      tooltip: {},
      userType: (this.$store.getters.getUser || {}).profile_type,
      employer: (this.$store.getters.getUser || {}).profile_type === 20,
      agree: false,
      image: (this.$store.getters.getUser.avatar_urls || {}).mid || (this.$store.getters.getUser.companylogo_urls || {}).main,
      cropped: false,
      imageLoading: false,
      phoneValid: true,
      showDeleteModal: false,
      disabled: {
        company_name: true,
        country: true,
        region: true
      },
      userExportUrl: '',
      showDownloadPersonalData: false,
      stayingTypes: [],
      showPassFields: false,
      showDeleteFields: false,
      changePassFields: {
        current_password: '',
        new_password1: '',
        new_password2: ''
      },
      deleteAccountFields: {
        current_password: ''
      },
      errors: {},
      form: {
        first_name: this.$store.getters.getUser.first_name,
        last_name: this.$store.getters.getUser.last_name,
        birth_date: this.$store.getters.getUser.birth_date,
        country: this.$store.getters.getUser.country,
        region: this.$store.getters.getUser.region || {},
        email: this.$store.getters.getUser.email,
        company_reg_number: this.$store.getters.getUser.company_reg_number,
        company_name: this.$store.getters.getUser.company_name,
        company_type: this.$store.getters.getUser.company_type || {},
        company_type_name: '',
        contact_person: this.$store.getters.getUser.contact_person,
        contact_phone: this.$store.getters.getUser.contact_phone,
        contact_website: this.$store.getters.getUser.contact_website,
        company_about: this.$store.getters.getUser.company_about,
        image: this.$store.getters.getUser.avatar_imgid || this.$store.getters.getUser.companylogo_imgid || '',
        marital_status: (this.$store.getters.getUser.marital_status || {}).id,
        gender: this.$store.getters.getUser.gender,
        location_country: this.$store.getters.getUser.location_country || {},
        location_region: this.$store.getters.getUser.location_region || {},
        location_staying_type: (this.$store.getters.getUser.location_staying_type || {}).id || {}
      }
    }
  },
  validations () {
    if (!this.employer) {
      return {
        form: {
          first_name: {
            required
          },
          last_name: {
            required
          },
          country: {
            required
          },
          location_country: {
            required
          },
          location_region: {
            required
          },
          location_staying_type: {
            required
          }
        },
        changePassFields: {
          current_password: {
            required: requiredIf(() => {
              return !this.getUser.has_password
            })
          },
          new_password1: {
            required
          },
          new_password2: {
            required,
            sameAsPassword: sameAs('new_password1')
          }
        },
        deleteAccountFields: {
          current_password: {
            required
          }
        }
      }
    } else {
      return {
        form: {
          email: {
            required,
            email
          },
          country: {
            required
          },
          region: {
            required
          },
          contact_person: {
            required
          },
          contact_phone: {
            required
          },
          company_name: {
            required
          },
          company_type: {
            required
          },
          company_reg_number: {
            required
          }
        },
        changePassFields: {
          current_password: {
            required
          },
          new_password1: {
            required
          },
          new_password2: {
            required,
            sameAsPassword: sameAs('new_password1')
          }
        },
        deleteAccountFields: {
          current_password: {
            required
          }
        }
      }
    }
  },
  methods: {
    ...mapActions([
      'logout',
      'jobseekerProfileUpdate',
      'employerProfileUpdate',
      'getCompanyType',
      'uploadImage',
      'changePassword',
      'jobseekerGetCvs',
      'receiveStayingTypes',
      'deactivateAccount',
      'getUserExportUrl'
    ]),
    ...mapMutations([
      'removeCache'
    ]),
    gettext: gettext,
    countryUpdateHandler () {
      this.form.location_staying_type = ''
      this.form.location_region = ''
    },
    downloadPersonalData () {
      this.showDownloadPersonalData = true
      this.getUserExportUrl({lang: this.getLanguage}).then(res => {
        this.userExportUrl = res.url
      })
    },
    getStayingTypes () {
      this.receiveStayingTypes({lang: this.getLanguage, id: this.form.location_country.id}).then(res => {
        this.stayingTypes = res
      })
    },
    exit () {
      this.logout()
    },
    imageNormalize (img) {
      if (img) return img.replace(/.*(,)/, '')
    },
    loadImage (value) {
      return new Promise(resolve => {
        if (value) {
          this.imageLoading = true
          this.uploadImage({lang: this.getLanguage, img: this.imageNormalize(value), profile: this.employer ? 'companylogo' : 'avatar'}).then(res => {
            this.image = (res.variants.mid || {}).full_url || (res.variants.wide_mid || {}).full_url
            this.form.image = res.imgid
            this.imageLoading = false
            resolve(res)
          })
        }
      })
    },
    updateProfile () {
      this.$refs.imageCropper.autoCrop()
      if (this.employer) {
        this.updateEmployer()
      } else {
        this.updateJobseeker()
      }
    },
    updateJobseeker () {
      let data = {
        'lang': this.getLanguage,
        'tz': this.$store.getters.getUser.tz,
        'country': this.form.country.id || this.form.country,
        'first_name': this.form.first_name,
        'last_name': this.form.last_name,
        'birth_date': this.form.birth_date || '',
        'avatar_imgid': this.form.image,
        'marital_status': this.form.marital_status.id || null,
        'gender': this.form.gender,
        'location_country': (this.form.location_country || {}).id || (this.form.location_country[0] || {}).id,
        'location_region': (this.form.location_region || {}).id || (this.form.location_region[0] || {}).id,
        'location_staying_type': this.form.location_staying_type.id
      }
      this.jobseekerProfileUpdate({lang: this.getLanguage, data: data}).then(res => {
        toastr.success(gettext('Profile updated'), gettext('Success!'))
      }).catch((err) => {
        if ((err.data || {}).form_errors) {
          this.errorProcessor(err.data.form_errors, 'form')
        }
        toastr.error(gettext('Profile not updated'), gettext('Error!'))
      })
    },
    updateEmployer () {
      let data = {
        'lang': this.getLanguage,
        'tz': this.$store.getters.getUser.tz,
        'region': parseInt(this.form.region.id),
        'company_name': this.form.company_name,
        'contact_person': this.form.contact_person,
        'contact_phone': this.form.contact_phone,
        'contact_website': this.form.contact_website,
        'company_about': this.form.company_about,
        'companylogo_imgid': this.form.image,
        'company_type': parseInt(this.form.company_type.id),
        'company_reg_number': this.form.company_reg_number
      }
      this.employerProfileUpdate({lang: this.getLanguage, data: data}).then(() => {
        toastr.success(gettext('Request successfully sent'), gettext('Success!'))
      }).catch((err) => {
        if ((err.data || {}).form_errors) {
          this.errorProcessor(err.data.form_errors, 'form')
        }
        toastr.error(gettext('Profile not updated'), gettext('Error!'))
      })
    },
    errorProcessor (error, attr, name) {
      _.each(error, (item, key) => {
        if (_.has(this.$data[attr], key)) {
          this.$data[attr][key] = ''
          if (name) {
            this.$set(this.errors.server, name, {})
            this.$set(this.errors.server[name], key, item[0].message)
          } else {
            this.$set(this.errors.server, key, item[0].message)
          }
        }
        this.$v.$touch()
        this.validateData(key, name)
      })
    },
    validateData (item, model = 'form') {
      if (item && this.$v[model][item]) {
        this.$v[model][item].$touch()
        if (this.$v[model][item].$error) {
          this.$set(this.tooltip, item, true)
          setTimeout(() => {
            this.$nextTick(() => {
              this.tooltip[item] = false
            })
          }, 3000)
        }
      } else {
        this.$v.$touch()
        let errors = this.$v[model]
        _.each(errors, (item, key) => {
          if (!key.includes('$')) {
            if (errors[key].$error) {
              this.$set(this.tooltip, key, true)
            }
          }
        })
        setTimeout(() => {
          _.each(this.tooltip, (item, key) => {
            this.tooltip[key] = false
          })
        }, 3000)
      }
    },
    changePass () {
      this.showPassFields = true
      if (this.showPassFields && this.formPassIsValid) {
        this.changePassword({lang: this.getLanguage, form: this.changePassFields}).then(res => {
          toastr.success(gettext('Request successfully sent'), gettext('Your password has been successfully updated!'))
        }).catch(err => {
          if ((err.data || {}).form_errors) {
            this.errorProcessor(err.data.form_errors, 'changePassFields', 'changePassFields')
          }
        })
      }
    },
    deleteAccount () {
      this.showDeleteFields = true
      if ((this.showDeleteFields && this.formDelIsValid) || !this.getUser.has_password) {
        this.deactivateAccount({lang: this.getLanguage, form: this.deleteAccountFields}).then(res => {
          if (!this.getUser.has_password) {
            this.logout({name: 'Login', query: {deletedSocialAccount: true}})
          } else {
            this.logout({name: 'Login', query: {deletedAccount: true}})
          }
        }).catch(err => {
          if ((err.data || {}).form_errors) {
            this.errorProcessor(err.data.form_errors, 'deleteAccountFields', 'deleteAccountFields')
          }
        })
      }
    },
    toogleInfoshow (item) {
      this.$set(this.tooltip, item, true)
      setTimeout(() => {
        this.$nextTick(() => {
          this.tooltip[item] = false
        })
      }, 3000)
    },
    setErrorsText () {
      this.errors = {
        first_name: gettext('This field is required'),
        last_name: gettext('This field is required'),
        birth_date: gettext('This field is required'),
        country: gettext('This field is required'),
        region: gettext('This field is required'),
        email: gettext('This field is required'),
        new_password: gettext('This field is required'),
        company_reg_number: gettext('This field is required'),
        contact_person: gettext('This field is required'),
        contact_phone: gettext('This field is required'),
        company_name: gettext('This field is required'),
        company_type: gettext('This field is required'),
        gender: gettext('This field is required'),
        server: {}
      }
    }
  },
  watch: {
    getLanguage: function () {
      this.setErrorsText()
    }
  },
  created () {
    this.setErrorsText()
  },
  computed: {
    ...mapGetters([
      'getLanguage',
      'getFinanceAccount',
      'getUser'
    ]),
    regionAction () {
      return {
        method: 'receiveRegions',
        params: {
          lang: this.getLanguage,
          country: this.form.location_country.id ? this.form.location_country.iso2 : '',
          sortBy: 'name'
        }
      }
    },
    placementAction () {
      return {
        method: 'receiveStayingTypes',
        params: {
          lang: this.getLanguage,
          id: this.form.location_country.id
        }
      }
    },
    allowEdit () {
      if (
        !this.$store.getters.getUser.company_reg_number &&
        !this.$store.getters.getUser.company_name &&
        !this.$store.getters.getUser.company_type &&
        !this.$store.getters.getUser.region
      ) {
        return true
      }
      return false
    },
    defaultMetaInfo () {
      return {
        title: 'Bixter | ' + gettext('Profile'),
        titleTemplate: null,
        link: [
          {rel: 'canonical', href: document.location.origin + document.location.pathname}
        ]
      }
    },
    formIsValid: function () {
      return !this.$v.form.$invalid
    },
    formPassIsValid: function () {
      return !this.$v.changePassFields.$invalid
    },
    formDelIsValid: function () {
      return !this.$v.deleteAccountFields.$invalid
    },
    nonFilled () {
      return this.$store.getters.getUser.non_filled_fields
    }
  }
}
</script>

<style lang='scss' src='./styles.scss'></style>



// WEBPACK FOOTER //
// src/pages/profile/index.vue